import { Roles } from "@/models/user.model";
import { Views } from "@/views";
import { RouteRecordRaw } from "vue-router";
import { guardAdmin, guardAuth, guardStudent, guardTeacher } from "./guards";
import { guardUser } from "./guards/user.guard";
import FormTheme from "@/views/EditUser/Theme/form.vue";

export const authenticated: Array<RouteRecordRaw> = [
  {
    path: "/dashboard-student",
    name: "dashboardStd",
    component: Views.DashboardStd,
    beforeEnter: guardStudent,
    meta: { auth: true, topbarCollapse: true },
  },
  {
    path: "/faq",
    name: "faq",
    component: Views.FAQ,
    beforeEnter: guardStudent,
    meta: { auth: true },
  },
  {
    path: "/dashboard-teacher",
    name: "dashboardTeacher",
    component: Views.DashboardTeacher,
    beforeEnter: guardTeacher,
    meta: { auth: true },
  },
  {
    path: "/form-course/:id?",
    name: "formCourse",
    component: Views.FormCourse,
    beforeEnter: guardTeacher,
    meta: { auth: true },
  },
  {
    path: "/form-chapter-traditional/:courseId/:chapterId?/:tab",
    name: "formChapterTraditional",
    component: Views.FormChapterTraditional,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
      traditional: true,
    },
  },
  {
    path: "/form-objective-traditional/:courseId/:chapterId/:objectiveId?",
    name: "formObjectiveTraditional",
    component: Views.FormsObjectiveTraditional,
    beforeEnter: guardTeacher,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
      traditional: true,
    },
  },
  {
    path: "/form-objective/:courseId/:chapterId/:id?/:tab",
    name: "formObjective",
    component: Views.FormObjectives,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: { auth: true, topbarCollapse: true, hasContainer: false },
  },
  {
    path: "/form-object/:objectiveId/:id?/:courseId?/:type",
    name: "formObject",
    component: Views.FormObjects,
    beforeEnter: guardTeacher,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/form-object-traditional/:objectiveId/:courseId?/:id?/:type",
    name: "formObjectTraditional",
    component: Views.FormObjects,
    beforeEnter: guardTeacher,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/form-objective/:courseId/:chapterId/:objectiveId/lesson-plan/:lessonPlanId",
    name: "lessonPlan",
    component: Views.AddMaterialLesson,
    beforeEnter: guardTeacher,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/form-question/:quizId/:objectiveId/:id?",
    name: "formQuestion",
    component: Views.FormQuestion,
    beforeEnter: guardTeacher,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/form-question-traditional/:quizId/:objectiveId/:id?",
    name: "formQuestionTraditional",
    component: Views.FormQuestionTraditional,
    beforeEnter: guardTeacher,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/chapters/:id/:type?/:h5pId?",
    name: "chapters",
    component: Views.Chapters,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: { topbarCollapse: true, hasContainer: false },
  },
  {
    path: "/stats",
    name: "stats",
    component: Views.Stats,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: { auth: true, topbarCollapse: true, hasContainer: false },
  },
  {
    path: "/stats/course/:courseId/:courseName",
    name: "statsCourse",
    component: Views.CourseStats,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: { auth: true, topbarCollapse: true, hasContainer: false },
  },
  {
    path: "/stats/student/:studentId/:studentName/:courseId",
    name: "statsStudent",
    component: Views.StudentStats,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: { auth: true, topbarCollapse: true, hasContainer: false },
  },
  {
    path: "/stats/objective/:courseId/:objectiveId/:objectiveName",
    name: "statsObjective",
    component: Views.ObjectiveStats,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.TEACHER, Roles.ADMINISTRATOR]),
    meta: { auth: true, topbarCollapse: true, hasContainer: false },
  },
  {
    path: "/dashboard-admin",
    name: "dashboardAdm",
    component: Views.DashboardAdm,
    beforeEnter: guardAdmin,
    meta: { auth: true },
  },
  {
    path: "/organizations/org-registration/:organizationId?/:tab?",
    name: "formsOrganizations",
    component: Views.FormsOrganizations,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.APPLICATION_ADMIN]),
    meta: { auth: true },
  },
  {
    path: "/organizations",
    name: "organizations",
    component: Views.Organizations,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.APPLICATION_ADMIN]),
    meta: { auth: true },
  },
  {
    path: "/themes",
    name: "themes",
    component: Views.Themes,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.APPLICATION_ADMIN]),
    meta: { auth: true },
  },
  {
    path: "/theme/:id",
    name: "theme",
    component: FormTheme,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.ADMINISTRATOR, Roles.APPLICATION_ADMIN]),
    meta: { auth: true, topbarCollapse: true },
  },
  {
    path: "/about",
    name: "about",
    component: Views.About,
    beforeEnter: guardAuth,
    meta: { auth: true },
  },
  {
    path: "/users",
    name: "users",
    component: Views.Users,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.APPLICATION_ADMIN, Roles.ADMINISTRATOR]),
    meta: { auth: true },
  },
  {
    path: "/users-form/:id?/:role?",
    name: "formUser",
    component: Views.FormUsers,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.APPLICATION_ADMIN, Roles.ADMINISTRATOR]),
    meta: { auth: true },
  },
  {
    path: "/general-settings",
    name: "generalSettings",
    component: Views.GeneralSettings,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [Roles.APPLICATION_ADMIN]),
    meta: { auth: true },
  },
  {
    path: "/:courseName/:id/info",
    name: "courseInformation",
    component: Views.CourseInformation,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
    },
  },
  {
    path: "/:courseName/:id/linear-info",
    name: "courseLinearInformation",
    component: Views.CourseInformation,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourseTraditional: true,
      topbarCollapse: true,
    },
  },
  {
    path: "/:courseName/:id/content",
    name: "courseContent",
    component: Views.CourseContent,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
      hasContainer: false,
      disableFooter: true,
    },
  },
  {
    path: "/:courseName/:id/interactive",
    name: "interactiveCourseContent",
    component: Views.H5PContent,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
      disableFooter: true,
    },
  },
  {
    path: "/:courseName/:id/linear-content",
    name: "traditionalCourseContent",
    component: Views.TraditionalContent,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourseTraditional: true,
      topbarCollapse: true,
      hasContainer: false,
      disableFooter: true,
    },
  },
  {
    path: "/:courseName/:id/my-performance",
    name: "courseQuizResults",
    component: Views.CourseQuizResults,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/:courseName/:id/my-linear-performance",
    name: "courseLinearQuizResults",
    component: Views.CourseQuizResults,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourseTraditional: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/forum",
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
      groupRouteFrom: "forum",
      pageCourseTraditional: null,
    },
    children: [
      {
        path: "",
        name: "listForums",
        component: Views.ListForums,
        beforeEnter: (to, from, next) =>
          guardUser(to, from, next, [
            Roles.ADMINISTRATOR,
            Roles.TEACHER,
            Roles.APPLICATION_ADMIN,
          ]),
      },
      {
        path: "/:courseName/:id/forum",
        name: "forum",
        component: Views.Forum,
        beforeEnter: guardAuth,
      },
      {
        path: "/:courseName/:id/forum/create",
        name: "addTopic",
        component: Views.FormTopic,
        beforeEnter: guardAuth,
      },
      {
        path: "/:courseName/:id/forum/:topicId",
        name: "topicDetail",
        component: Views.TopicDetail,
        beforeEnter: guardAuth,
      },
      {
        path: "/:courseName/:id/forum/:topicId/edit",
        name: "editTopic",
        component: Views.FormTopic,
        beforeEnter: guardAuth,
      },
      {
        path: "/:courseName/:id/forum/:topicId/:commentId/edit",
        name: "editComment",
        component: Views.EditComment,
        beforeEnter: guardAuth,
      },
    ],
  },
  {
    path: "/:courseName/:id/how-it-works",
    name: "howItWorks",
    component: Views.CourseHowWorks,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      topbarCollapse: true,
      hasContainer: false,
    },
  },
  {
    path: "/:courseName/:id/calendar",
    name: "calendarStudent",
    component: Views.Calendar,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
      hasContainer: true,
      pageCourseTraditional: null,
    },
  },
  {
    path: "/:courseName/:id/activities",
    name: "studentActivities",
    component: Views.StudentActivities,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
      hasContainer: true,
      pageCourseTraditional: null,
      groupRouteFrom: "activities",
    },
  },
  {
    path: "/:courseName/:id/activities/details/:activityId?",
    name: "activityStudentDetail",
    component: Views.StudentActivityDetail,
    beforeEnter: guardStudent,
    meta: {
      auth: true,
      pageCourse: true,
      topbarCollapse: true,
      hasContainer: true,
      pageCourseTraditional: null,
      groupRouteFrom: "activities",
    },
  },
  {
    path: "/quiz",
    name: "quiz",
    component: Views.QuizStudent,
    beforeEnter: guardStudent,
    meta: { auth: true, topbarCollapse: true },
  },
  {
    path: "/edit-user",
    name: "editUser",
    component: Views.EditUser,
    beforeEnter: guardAuth,
    meta: { auth: true, topbarCollapse: true },
  },
  {
    path: "/blacklist-keywords/:objectiveId",
    name: "blacklist",
    component: Views.Blacklist,
    beforeEnter: guardTeacher,
    meta: { topbarCollapse: true, hasContainer: true },
  },
  {
    path: "/classes",
    meta: {
      auth: true,
      topbarCollapse: true,
      groupRouteFrom: "classes",
    },
    children: [
      {
        path: "",
        name: "classes",
        component: Views.Classes,
        beforeEnter: guardAuth,
      },
      {
        path: "form-activity/:id?",
        name: "formActivity",
        component: Views.FormActivity,
        beforeEnter: guardAuth,
      },
      {
        path: "activity-detail/:id?",
        name: "activityDetail",
        component: Views.ActivityDetail,
        beforeEnter: guardAuth,
      },
    ],
  },
  {
    path: "/form-classes/:id?/:tab",
    name: "formClasses",
    component: Views.FormClasses,
    beforeEnter: guardAuth,
    meta: { auth: true, topbarCollapse: true },
  },
  {
    path: "/calendar",
    name: "calendar",
    component: Views.Calendar,
    beforeEnter: (to, from, next) =>
      guardUser(to, from, next, [
        Roles.APPLICATION_ADMIN,
        Roles.ADMINISTRATOR,
        Roles.TEACHER,
      ]),
    meta: { auth: true, topbarCollapse: true },
  },
];
